import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  signed: false,
  loading: false,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_REQUEST':
      case '@auth/SIGN_UP_REQUEST':
      case '@auth/LOADING_START': {
        draft.loading = true;
        break;
      }

      case '@auth/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.signed = true;
        draft.loading = false;
        break;
      }

      case '@auth/SIGN_FAILURE': {
        draft.signed = false;
        draft.loading = false;
        break;
      }

      case '@auth/LOADING_END': {
        draft.loading = false;
        break;
      }

      case '@auth/SIGN_OUT': {
        draft.loading = false;
        draft.signed = false;
        break;
      }

      default:
    }
  });
}
